export const TRANCHE_POLICY_TYPE = {
  SubtractPercentage: 1,
  SubtractAmount: 2,
  AddPercentage: 3,
  AddAmount: 4,
};

export const TRANCHE_POLICY_TYPE_LABELS = {
  [TRANCHE_POLICY_TYPE.SubtractPercentage]: "odejmij %",
  [TRANCHE_POLICY_TYPE.SubtractAmount]: "odejmij kwotę",
  [TRANCHE_POLICY_TYPE.AddPercentage]: "dodaj %",
  [TRANCHE_POLICY_TYPE.AddAmount]: "dodaj kwotę",
};

export const TRANCHE_POLICY_TYPE_OPTIONS = Object.entries(
  TRANCHE_POLICY_TYPE_LABELS
).map(([value, label]) => ({
  value,
  label,
}));
